export const ROLES = {
  SYSTEM_ADMIN: 'SystemAdmin',
  MANAGER: 'Manager',
  SALES_REP: 'SalesRep',
  OPERATIONS: 'Operations',
  ANALYST: 'Analyst',
  VIEWER: 'Viewer'
};
